export default {
  apiKey: 'AIzaSyAz7eqo1ZDoF_0KxWFkM-WFYs1vHYLRe1w',
  authDomain: 'cs473-whitecell.firebaseapp.com',
  databaseURL: 'https://cs473-whitecell.firebaseio.com',
  projectId: 'cs473-whitecell',
  storageBucket: 'cs473-whitecell.appspot.com',
  messagingSenderId: '544256099198',
  appId: '1:544256099198:web:ebcda5934e5108375de92f',
  measurementId: 'G-6ERMJDGN7L'
}
